import React, { useEffect, useState, useContext } from "react";
import { Table } from "antd";
import { v4 as uuidv4 } from 'uuid';
import { GlobalContext } from "../../contexts/GlobalContext";
import { surveyService } from "../../services";

const columns = [
    /*
    zakomentirano jer su vraćali podatke koji su nebitni
    {
        title: "Jedinica lokalne samouprave",
        dataIndex: "jls",
        key: uuidv4(),
        align: 'left',
        width: '35%',
        sorter: (a, b) => a.jls.localeCompare(b.jls),
    },*/
    {
        title: "Komentari i prijedlozi unaprjeđenja građana",
        dataIndex: "comment",
        key: uuidv4(),
        align: 'left',
        //sorter: (a, b) => a.comment.localeCompare(b.comment),
    },
    /*
    {
        title: "Broj",
        dataIndex: "num",
        key: uuidv4(),
        align: 'left',
        sorter: (a, b) => a?.num.localeCompare(b?.num),
    },*/
]

const CommentsWidget = (props) => {
    const {selectedMunicipality} = useContext(GlobalContext)
    const [data, setData] = useState([])

    const getComments = async () =>{
        let response = await surveyService.getSurveyAnalytics("user_comment",6,selectedMunicipality?[selectedMunicipality?.id-21]:"")
        if(response) {
            setData(Object.keys(response).map(k => ({/*{jls: selectedMunicipality?.name || "Sve",*/ comment: k, /*, num: response[k] */})))
        }
        else{
            setData(null)
        }
    }



    useEffect(() => {
        const fetchData = async () => {
            await Promise.all([getComments()]);
        }
        
        fetchData();
    }, [selectedMunicipality])


    return (
        <Table className="not-draggable" {...props} columns={columns} dataSource={data} size="small" bordered />
    )
}

export default CommentsWidget;